import { useState } from 'react';
import { cn } from 'lib/cn';
import { Modal, Button } from 'components/ui';

/**
 * Pick a rejection reason for a product request, then submit via vendorSwipeLeft.
 * Render with a `key` of the notification id so the selection resets per item.
 */
export function RejectNotificationModal({ notification, reasons, loading, onConfirm, onClose }) {
  const [reason, setReason] = useState('');

  return (
    <Modal
      isOpen={Boolean(notification)}
      onClose={onClose}
      title="Why is it not available?"
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => onConfirm(reason)} isLoading={loading} disabled={!reason}>
            Submit
          </Button>
        </>
      }
    >
      <div className="flex flex-wrap gap-2">
        {reasons.map((entry) => (
          <button
            key={entry.value}
            type="button"
            onClick={() => setReason(entry.value)}
            className={cn(
              'rounded-full px-3 py-1.5 text-sm font-medium transition',
              reason === entry.value
                ? 'bg-brand-600 text-white'
                : 'bg-white text-slate-600 ring-1 ring-inset ring-surface-300 hover:text-slate-900',
            )}
          >
            {entry.displayValue}
          </button>
        ))}
      </div>
    </Modal>
  );
}

export default RejectNotificationModal;
